import type {
  KambiJerseysForEventData,
  KambiPlayerJersey,
} from '@mobi/sports-offering/helpers/api/shapeGames'

export function getPlayerJersey(
  eventJerseys: KambiJerseysForEventData | undefined,
  participantId: number
): KambiPlayerJersey | undefined {
  const eventParticipants = eventJerseys?.event_participants

  const eventParticipant = eventParticipants?.[0]

  const teamPlayers = [
    ...(eventParticipant?.home?.team_player_icons?.team_players ?? []),
    ...(eventParticipant?.away?.team_player_icons?.team_players ?? []),
  ]

  return teamPlayers.find(player => player.player_id === String(participantId))
}
